import React from 'react';
import { useTranslation } from 'react-i18next';

import { ListProps } from 'component/Layout/Autocomplete/types';

import { ReactComponent as IconLocationPinOutline } from 'media/svg/locationPinOutline.svg';

import styles from '../../Destination.module.scss';
import { TopRegion } from '../../types';

const TopRegionList = ({ entries, onClick }: ListProps<TopRegion>) => {
    const { t } = useTranslation();
    if (entries.length === 0) {
        return null;
    }

    return (
        <>
            <hr className={styles.Line} />
            <div className={styles.Header}>
                {t('TRANS-most-popular-destinations')}
            </div>
            <ul className={styles.ResultList}>
                {entries?.map((entry) => (
                    <li
                        className={styles.ListItem}
                        key={entry.regionId}
                        onClick={() => onClick?.(entry)}
                    >
                        <div className={styles.ListItemContent}>
                            <div className={styles.Icon}>
                                <IconLocationPinOutline />
                            </div>
                            <em className={styles.Entry}>{entry.name}</em>
                            <span className={styles.ListItemAddition}>
                                {entry.countryName}
                            </span>
                        </div>
                    </li>
                ))}
            </ul>
        </>
    );
};

export default TopRegionList;
